import Request from '@/jslib/dk-axios'

export const login = (data) => {
  return Request({
    url: 'Login',
    method: 'POST',
    data,
  })
}
export const changePassword = (data) => {
  return Request({
    url: `AdminUser/${data.uuid}`,
    method: 'PUT',
    data,
  })
}
//  === 这个没用 === 后面可能有其他这个模块的接口，暂时不使用 default
export const test = (data) => {
  return Request({
    url: 'Login',
    method: 'POST',
    data,
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js